import React, { useContext } from "react";
import { serviceData } from "../constants";
import { ThemeContext } from "../themeProvider";
import { motion } from "framer-motion";

const Services = () => {
  const theme = useContext(ThemeContext);
  return (
    <div
      className={
        theme.state.darkMode ? "pb-20 bg-fixed bg-gray-100" : "pb-20 bg-black"
      }
      // style={{backgroundImage: `url('https://i.pinimg.com/originals/b0/b1/f5/b0b1f5d33de00e3c21ad29bbba25e31b.gif')`}}>
    >
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 px-4 pt-20"
        id="services"
      >
        <h2
          className={
            theme.state.darkMode
              ? "text-5xl font-bold px-4 md:px-0 text-center"
              : "text-5xl font-bold px-4 md:px-0 text-center text-white"
          }
        >
          Projects
        </h2>
        <div className="">
          <h4 className="mt-16 text-3xl font-semibold text-blue-500">
          What I Built
          </h4>
          <div className="mt-8 flex md:flex-row justify-between justify-evenly flex-col md:items-stretch items-center ">
            {serviceData.map((el) => (
              <motion.div
                initial="hidden"
                whileInView={"visible"}
                variants={{
                  visible: { opacity: 1, scale: 1 },
                  hidden: { opacity: 0, scale: 0 },
                }}
                className={
                  theme.state.darkMode
                    ? "md:w-96 p-4 bg-white rounded-lg flex items-center  flex-col mt-8"
                    : "md:w-96 p-4 bg-gray-100 rounded-lg flex items-center  flex-col mt-8"
                }
              >
                <img src={el.img} alt="" />
                <h4 className="text-xl font-bold mt-4">{el.name}</h4>
                <p className="text-lg mt-2 text-justify">{el.desc}</p>
                <div class="flow-root">
                <h5 className="text-lg font-bold mt-4 float-left -ml-3.5">Link:</h5>
                <a href={el.url} className="ml-2 text-sm font-semibold text-blue-700 block lowercase float-right m-5 .w-11/12">{el.url}</a>
                </div>
                <h5 className="text-lg font-bold float-left -ml-3.5 underline">TechStack</h5>
                <p className="text-lg ml-2 block float-right m-5 .w-11/12">{el.tech}</p> 
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
